import {FleetOwnerPortalService} from "@bolteu/bolt-server-api-fleet-owner-portal";

import ColumnType = FleetOwnerPortalService.ColumnType;

export function getUniqueColumnIndex(columnType: ColumnType, columnTitle: string): string {
    return `${columnType}_${columnTitle.toLowerCase().replace(" ", "_")}`;
}
